// removed by extract-text-webpack-plugin
module.exports = {"collapsed":"_2L1RKR","btn":"_35Co5b","overflowingPassive":"_3tZ-ar","overflowing":"w6V23N","content":"_287hFV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapsed/collapsed-style.css
// module id = 286
// module chunks = 0